import { useContext, useLayoutEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import AuthContext from "../context/auth.context";
import useAuth from "../hooks/auth.hook";
import DashboardOrdersList from "./dashboard/components/DashboardOrdersList";
import StatsGrid from "./dashboard/components/StatsGrid";

import "./DashboardPage.css";

const PERIODS = [
  { id: 1, label: "Сегодня" },
  { id: 2, label: "Вчера" },
  { id: 3, label: "Неделя" },
  { id: 6, label: "Прош. неделя" },
  { id: 4, label: "Месяц" },
  { id: 7, label: "Прош. месяц" },
  { id: 8, label: "Этот год" },
  { id: 9, label: "Прош. год" },
  { id: 5, label: "Все время" },
];

function DashboardPage() {
  const navigate = useNavigate();
  const { branchId, tgChannelId } = useParams();
  const { ready } = useAuth();
  const { token } = useContext(AuthContext);
  const [periodId, setPeriodId] = useState(1);
  const periodTabRefs = useRef({});
  const [dashboardBodyEl, setDashboardBodyEl] = useState(null);

  useLayoutEffect(() => {
    const el = periodTabRefs.current[periodId];
    el?.scrollIntoView({
      inline: "center",
      block: "nearest",
      behavior: "smooth",
    });
  }, [periodId]);

  if (!ready) {
    return (
      <div className="dashboard">
        <p className="dashboard-state">Загрузка…</p>
      </div>
    );
  }

  if (!token) {
    return (
      <div className="dashboard">
        <p className="dashboard-state">
          Нет токена. Откройте приложение по ссылке из канала.
        </p>
      </div>
    );
  }

  const createOrderHref = `/operator/${encodeURIComponent(tgChannelId)}/branch/${encodeURIComponent(branchId)}/orders/create`;

  return (
    <div className="dashboard">
      <div className="dashboard-body" ref={setDashboardBodyEl}>
        <StatsGrid periodId={periodId} />
        <div className="dashboard-periods" role="tablist" aria-label="Период">
          {PERIODS.map((p) => (
            <button
              key={p.id}
              ref={(node) => {
                periodTabRefs.current[p.id] = node;
              }}
              type="button"
              role="tab"
              aria-selected={periodId === p.id}
              className={
                periodId === p.id
                  ? "dashboard-period dashboard-period-active"
                  : "dashboard-period"
              }
              onClick={() => setPeriodId(p.id)}
            >
              {p.label}
            </button>
          ))}
        </div>
        <DashboardOrdersList scrollRoot={dashboardBodyEl} />
        <footer className="dashboard-createFooter">
          <button
            type="button"
            className="dashboard-createButton"
            onClick={() => navigate(createOrderHref)}
            aria-label="Создать заказ"
            title="Создать заказ"
          >
            Создать заказ
          </button>
        </footer>
      </div>
    </div>
  );
}

export default DashboardPage;
